import { render, staticRenderFns } from "./PageFive.vue?vue&type=template&id=022b8714&scoped=true&"
import script from "./PageFive.vue?vue&type=script&lang=js&"
export * from "./PageFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022b8714",
  null
  
)

export default component.exports